<template>
	<div>
		<v-form>
			<v-container grid-list-xl fluid>
					<v-layout row wrap>
						<v-flex lg5 class="left-text">

							<v-card class="mb-4">
						<v-toolbar flat dense cad>
							<v-toolbar-title class="subheading">Check In Detail</v-toolbar-title>
						</v-toolbar>
						<v-divider></v-divider>

						<v-card-text>

								<v-select
								v-model="form.employee"
								prepend-icon="person"
								:items="allowedEmployees"
								:error-messages="employeeErrors"
								item-text="fullName"
								return-object
								label="Employee"
								required
								@change="onEmployeeSelect"
								@blur="$v.form.employee.$touch()"
							></v-select>

							<v-select
								v-model="form.reviewer"
								prepend-icon="person"
								:items="allowedReviewers"
								:error-messages="reviewerErrors"
								item-text="fullName"
								return-object
								label="Reviewer"
								required
								@change="$v.form.reviewer.$touch()"
								@blur="$v.form.reviewer.$touch()"
							></v-select>

							<v-menu
								ref="dueDateMenu"
								v-model="form.dueDateUtc.menu"
								:close-on-content-click="false"
								:nudge-right="40"
								:return-value.sync="form.dueDateUtc.date"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<v-text-field prepend-icon="date_range" slot="activator" v-model="dueDateFormatted" label="Due Date" readonly :error-messages="dueDateUtcErrors"></v-text-field>
								<v-date-picker v-model="form.dueDateUtc.date" @input="$refs.dueDateMenu.save(form.dueDateUtc.date)"></v-date-picker>
							</v-menu>
							
						</v-card-text>
							</v-card>		
						</v-flex>	

						<v-flex lg7 class="left-text">
							
							<check-in-item-builder :items="form.reviewItems" @onItemsUpdated="onItemsUpdated" class="mb-4"/>

						</v-flex>

						
				</v-layout>

			</v-container>
		</v-form>

			<v-footer color app height="55">
				<v-spacer></v-spacer>
				<footer-back-btn @click="$router.push(`/checkIns`)" />

				<v-btn class="action-btn" @click="submit" :loading="isSaving" :disabled="isSaving">
					Create Check In
					<span slot="loader">Saving...</span>
				</v-btn>
			</v-footer>

	</div>
</template>

<script>
	import moment from 'moment';
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import CheckInItemBuilder from '@/components/checkin/CheckInItemBuilder';

	export default {
		props: {
			loggedInEmployee: {
				required: true
			},
			employees: {
				required: true
			},
			templates: {
				type: Array,
				required: true
			},
			isSaving: {
				type: Boolean,
				required: true
			}
		},
		components: {
			CheckInItemBuilder
		},
		data() {
			return {
				form: {}
			};
		},
		computed: {
			allowedEmployees() {
				if (!this.employees) {
					return []
				};
				
				let filterFunc = () => true;

				if (this.loggedInEmployee.isAdmin) {
					return this.employees.filter(filterFunc);
				}

				let underlings = this.loggedInEmployee.underlings;
				if (underlings !== null) {
					return this.employees.filter(x=> underlings.includes(x.id) || x.id === this.loggedInEmployee.id);
				}

				return this.loggedInEmployee;
			},
			allowedReviewers() {
				if (this.form.employee) {
					return this.employees.filter(x => x.id !== this.form.employee.id);
				}

				return this.employees;
			},
			employeeErrors() {
				const errors = [];
				if (!this.$v.form.employee.$dirty) return errors;
				!this.$v.form.employee.required && errors.push('Employee is required.');
				return errors;
			},
			reviewerErrors() {
				const errors = [];
				if (!this.$v.form.reviewer.$dirty) return errors;
				!this.$v.form.reviewer.required && errors.push('Reviewer is required.');
				return errors;
			},
			dueDateFormatted() {
				return this.$options.filters.formatDate(this.form.dueDateUtc.date);
			},
			dueDateUtcErrors() {
				const errors = [];
				if (!this.$v.form.dueDateUtc.date.$dirty) return errors;
				!this.$v.form.dueDateUtc.date.required && errors.push('Due Date is required.');
				return errors;
			},
			noQuestions() {
                return this.form.reviewItems == null || this.form.reviewItems.length === 0;
            }
		},
		mixins: [validationMixin],
		validations() {
			return {
				form: {
					employee: { required },
					reviewer: { required },
					dueDateUtc: { date: { required } }
				}
			};
		},
		created () {
			this.form = JSON.parse(JSON.stringify(this.templates[0]));
			this.form.dueDateUtc = {
					date: this.$options.filters.formatDate(this.calculateNextDueDate(), 'YYYY-MM-DD'),
					menu: false
				}
		},
		methods: {
			submit() {
				if(this.noQuestions) {
					alert('You must add at least 1 question in order to save the Check In');
					return;
				}

				this.$v.form.$touch();
				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					if (confirm('Are you sure you wish to save this Check In?')) {
						const postObj = Object.assign({}, this.form);
						postObj.dueDateUtc = this.form.dueDateUtc.date;
						this.$emit('save', postObj);
					}
				}
			},
			cancel() {
				this.$emit('cancel');
			},
			onEmployeeSelect(employee) {
				this.form.employee = employee;

				if (employee.reportsTo !== null) {
					this.form.reviewer = this.employees.find(x => x.id === employee.reportsTo);
				}
			},
			calculateNextDueDate() {
				const dayINeed = 5;
				const today = moment().isoWeekday();
				if (today < dayINeed) { 
					return moment().isoWeekday(dayINeed);
				} else {
					return moment().add(1, 'weeks').isoWeekday(dayINeed);
				}
			},
			onItemsUpdated(items) {
				this.form.reviewItems = items;
			}
		}
	};
</script>

<style scoped>
	.check-in-answer-type > i {
		font-size: 1.4em;
	}

	.left-text {
		text-align: left;
	}

	.icon {
		display: inline-block;
		font-size: 1.4em;
		border-radius: 10px;
		margin-right: 2px;
	}

	i.very-happy {
		color: rgb(92, 182, 36);
	}

	i.happy {
		color: rgb(170, 195, 32);
	}

	i.neutral {
		color: rgb(244, 197, 17);
	}

	i.sad {
		color: rgb(246, 142, 31);
	}

	i.very-sad {
		color: rgb(245, 77, 28);
	}

	.tl-red {
		color: #f44336!important;
	}

	.tl-amber {
		color: #ffc107!important;
	}

	.tl-green {
		color: #4caf50 !important;
	}
</style>
